import { WORK_TYPES } from '@/constants/common/message.constants'
import { type WorkType } from '@/libs/api'

/**
 * 経由地の作業内容 (workType) プルダウンの選択肢。
 * 並びは API の WorkType enum の定義順（積込 → 荷降し → その他）
 */
export const WORK_TYPE_OPTIONS: { value: WorkType; label: string }[] = (
  Object.keys(WORK_TYPES) as WorkType[]
).map((value) => ({ value, label: WORK_TYPES[value] }))
